<template>
  <div ref="containerRef" class="animacion-elegante">
    <!-- Marco para el revelado limpio a pantalla completa -->
    <div ref="frameRef" class="foto-frame">
      <img
        ref="fotoRef"
        src="@/assets/30991_11zon.webp"
        alt="Foto destacada"
        class="foto-elegante-full"
        loading="lazy"
      />
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'AnimacionFotoPrincipal',
  setup() {
    const containerRef = ref(null)
    const frameRef = ref(null)
    const fotoRef = ref(null)
    let ctx = null

    onMounted(() => {
      ctx = gsap.context(() => {
        // Estado inicial ligero asignado directamente en GPU
        gsap.set([frameRef.value, fotoRef.value], {
          force3D: true
        })

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: containerRef.value,
            start: 'top 95%', // Aparece en cuanto entra un borde a la pantalla
            once: true // Se ejecuta una sola vez para matar procesos en segundo plano
          }
        })

        // 1. Revelado rápido y fluido en GPU
        tl.fromTo(
          frameRef.value,
          {
            y: 30,
            autoAlpha: 0
          },
          {
            y: 0,
            autoAlpha: 1,
            duration: 0.6,
            ease: 'power2.out'
          }
        )
        // 2. Micro-zoom suave y rápido (sin blur)
        .fromTo(
          fotoRef.value,
          {
            scale: 1.05
          },
          {
            scale: 1,
            duration: 0.8,
            ease: 'power1.out'
          },
          '-=0.5'
        )
      }, containerRef.value)
    })

    onUnmounted(() => {
      if (ctx) ctx.revert()
    })

    return {
      containerRef,
      frameRef,
      fotoRef
    }
  }
}
</script>


<style scoped>
.animacion-elegante {
  position: relative;
  width: 100vw; /* Fuerza el ancho total del viewport */
  margin-left: calc(-50vw + 50%); /* Rompe padding de contenedores padre */
  margin-right: calc(-50vw + 50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  
  margin-top: 20px;
  margin-bottom: -20px;
  padding: 0; /* Cero márgenes ni rellenos */
  overflow: hidden;
}

.foto-frame {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  border-radius: 0; /* Esquinas completamente rectas */
  will-change: transform, clip-path, opacity;
}

.foto-elegante-full {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
  will-change: transform, filter;
}
</style>